/**
 * Fichier GÉNÉRÉ par scripts/set-version.mjs à chaque `npm run build` / `npm start`.
 * Ne pas éditer : toute modification sera écrasée au prochain build.
 *
 * Les valeurs committées servent de repli si le script n'a pas tourné.
 */

/** Tag de la release construite, ex. 'v0.0.14'. Vide tant qu'aucune release n'a eu lieu. */
export const APP_VERSION = 'v0.0.15';

/** SHA court du commit construit, ex. '223e2b3'. Identifie l'artefact, pas la release. */
export const BUILD_SHA = '315f013';
